import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

const Text = styled.span`
  ${(props) => {
    const options = {};
    if (props.size) options.size = props.size;
    if (props.strong) options.strong = props.strong;
    const color = `var(--${props.color})` || 'currentcolor';
    return css`
      ${mixin.text(options)}
      color: ${color};
    `;
  }}
  ${({ editable }) =>
    editable &&
    css`
      padding: 4px;
      margin-left: -4px;
      ${mixin.borderRadius({ size: 200 })}

      &:hover {
        background: var(--neutral-200);
        color: var(--neutral-600);
      }
    `}
`;

export default Text;
